import React from 'react';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import TpClientLinkService from '../../../Services/tpClientLinkService';
import LinkTpClientToClientData from '../../Sales/ClientAdmin/LinkTpClientToClientData';
import TpSurveyItem from '../../../Domain/TpSurveyItem';
import TpSurveyService from '../../../Services/tpSurveyService';

export default class TpSurveyActivateWindowDescription extends React.Component {
  static titleForCreate = 'Activate Third-Party Survey';
  static titleForEdit = 'Activate Third-Party Survey';
  static ComponentName = 'TpSurveyActivateWindowDescription';
  static itemType = TpSurveyItem;
  static serviceFunction = (edited) => TpSurveyService.ActivateDeacivateSurvey(edited);

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'IsUninvoiceable',
          label: 'IsUninvoiceable',
          className: 'col-12',
          type: InputTypesEnum.EmptyYesNoSelect,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'SurveyType',
          label: 'Survey Type',
          className: 'col-12',
          type: InputTypesEnum.Select,
          selectvalues: TpSurveyActivateWindowDescription.getSelectOptions(),
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
      ],
    },
  ];

  static getSelectOptions() {
    return [
      {
        label: '',
        value: '',
      },
      {
        label: 'Calls Emails',
        value: 'CallsEmails',
      },
    ];
  }
}
